import { DatePicker } from 'element-ui';
import { FadeRenderTransition } from '@/components/index'
import AuthLayout from '@/components/user/register/auth-layout/auth-layout.vue'
import './register.css';

import ResourceSvc from '@/services/resource.svc.js';
const svc = new ResourceSvc();

export default {
    components: {
        FadeRenderTransition,
        AuthLayout,
        [DatePicker.name]: DatePicker
    },
    props: ['userId', 'securityCode'],
    data() {
        let defaultDateAdult = this.getDateAdult();
       
        return {
            isRegistered: false,
            isStartedRegistration: false,
            isResetPassword: Boolean(this.$route.query.securityCode),
            privacyPolicy: false,
            firstName: null,
            lastName: null,
            dob: null,
            email: null,
            password: null,
            passwordConfirmation: null,
            currentYear: null,
            pickerOptions: {
                disabledDate(date) {
                    return date > defaultDateAdult;
                }
            },
            defaultDate: defaultDateAdult
        }
    },
    computed: {
        oldAppLogin() {
            return process.env.url.oldApp;
        },
        newCMSLink() {
            return process.env.url.newCMS;
        },
        privacyPolicyUrl() {
            console.log(this.newCMSLink + '/our-privacy-policy/');
            return this.newCMSLink + '/our-privacy-policy/';
        }
    },

    methods: {
        getDateAdult() {
            let dateNow = new Date();
            let ageAdult = 18;
            return new Date(dateNow.getFullYear() - ageAdult, dateNow.getMonth(), dateNow.getDate());
        },
        initCurrentServerYear() {
            self = this;
            self.currentYear = null;
            svc.getCurrentServerYear()
                .then(response => {
                    if (response && response.body && response.body.isSuccess) {
                        self.currentYear = response.body.outputData;
                        self.pickerOptions = {
                            disabledDate(date) {
                                var startOfValidYear = self.getDateAdult();
                                return date > startOfValidYear;
                            }
                        }
                        self.defaultDate = self.getDateAdult();;
                    }
                });           
        },
        toggleNavbar() {
            document.body.classList.toggle('nav-open')
        },
        isValidData() {

            if (!this.firstName || !this.lastName || !this.dob || !this.email || !this.password || !this.passwordConfirmation) {
                this.$showError("All fields are mandatory to fill!");
                return false;
            }

            if (this.password != this.passwordConfirmation) {
                this.$showError("Passwords are not matched!");
                return false;
            }

            if (this.firstName.length < 3 || this.firstName.length > 50) {
                this.$showError("Firstname should contains from 3 to 50 characters!");
                return false;
            }

            if (this.lastName.length < 3 || this.lastName.length > 50) {
                this.$showError("Lastname should contains from 3 to 50 characters!");
                return false;
            }

            if (this.password.length < 8 || this.password.length > 20) {
                this.$showError("Password should contains from 8 to 20 characters!");
                return false;
            }
            
            if (!this.privacyPolicy) {
                this.$showError("You need to accept the Terms and Conditions to proceed!");
                return false;
            }

            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!re.test(String(this.email).toLowerCase())) {
                this.$showError("Email is incorrect!");
                return false;
            }

            return true;
        },
        saveData() {
            if (!this.isValidData()) {
                return;
            }
            var self = this;
            var data = {
                email: this.email,
                password: this.password,
                dob: this.dob,
                firstName: this.firstName,
                lastName: this.lastName
            };
            self.isStartedRegistration = true;
            svc.registerUser(data)
                .then(response => {
                    var allData = response.body;
                    self.isStartedRegistration = false;
                    if (!allData) {
                        self.$showError("Something went wrong! Data not received");
                        return;
                    }
                    if (!allData.isSuccess) {
                        self.$showError(allData.message);
                        return;
                    }
                    else {
                        self.isRegistered = true;
                        self.$showSuccess()
                    }
                }, response => {
                    self.$showError("Something went wrong, please contact with dev team!");
                });
        },
        closeMenu() {
            document.body.classList.remove('nav-open')
            document.body.classList.remove('off-canvas-sidebar')
        },
        changePassword() {
            const { email: login, password: newPassword, oldAppLogin } = this;
            const { securityCode } = this.$route.query;

            svc.confirmChangeUserPassword({ newPassword, securityCode, login })
              .then(({ body: { isSuccess, message } = {} }) => isSuccess
                ? location.href = oldAppLogin
                : this.$showError(message));
        }
    },
    beforeDestroy() {
        this.closeMenu()
    },
    created() {
        var self = this;
        self.initCurrentServerYear();
        setTimeout(function () {
            if (self.userId) {
                window.location.href = self.oldAppLogin;
            }
        }, 1000);
    }
}



// WEBPACK FOOTER //
// ./src/components/user/register/register.js